/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    leo<zhudongxian@frippler.com>
  | @Title:     登录/登出 API 接口
  | @Version:   2018-11-27  [A] 新建文件
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'
const jsApiHost = process.env.VUE_APP_GENERAL_API_HOST
export function getLoginConfigApi(query) {
  return request({
    url: '?c=login&a=visit',
    method: 'get'
  })
}

export function loginByUsernameApi(formData) {
  return request({
    url: '?c=login&a=login',
    method: 'post',
    data: formData
  })
}

export function loginSettingApi(formData) {
  return request({
    url: '?c=login&a=setting',
    method: 'post',
    data: formData
  })
}

export function logoutApi() {
  return request({
    url: '?c=login&a=logout',
    method: 'post'
  })
}


export function superFastLogin(data) {
  return request({
    url: jsApiHost + '/gateway/aiot/superFastLogin',
    method: 'post',
    data
  })
}

export function loginVerifyApi(data) {
  return request({
    url: `${ jsApiHost }/gateway/aiot/login/verify`,
    method: 'post',
    data
  })
}

export function loginConfirmApi(data) {
  return request({
    url: `${ jsApiHost }/gateway/aiot/login/confirm`,
    method: 'post',
    data
  })
}
